angular.module("app.modalControllers").controller("PaymentEditPageModalController", [
    '$scope',
    '$uibModalInstance',
    function ($scope, $modalInstance) {
        $scope.initModalInstance($modalInstance);
        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
